﻿import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { scBrandName } from '@/pages/pageListAll/pageOneSc/config';

export default [
  {
    path: '/IFPageOneHSixtySevenPreLogin',
    name: 'IFPageOneHSixtySevenPreLogin',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHSixtySevenLogin' ||
        from.path === '/IFPageOneHSixtySevenLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtySevenLogin',
    name: 'pageOneHSixtySevenLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/login.vue'),
  },
  {
    path: '/IFPageOneHSixtySevenLoginLoading',
    name: 'pageOneHSixtySevenLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtySevenLeaveInfo',
    name: 'pageOneHSixtySevenLeaveInfo',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtySevenResult',
    name: 'pageOneHSixtySevenResult',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/result.vue'),
  },
  {
    path: '/IFPageOneHSixtySevenLoading',
    name: 'pageOneHSixtySevenLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHSixtySevenLoginSecond',
    name: 'pageOneHSixtySevenLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/loginSecond.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneHSixtySevenOnline',
    name: 'pageOneHSixtySevenOnline',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/online.vue'),
    meta: {
      title: scBrandName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHSixtySevenLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHSixtySevenGuide',
    name: 'pageOneHSixtySevenLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/guide.vue'),
    meta: {
      title: scBrandName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
    path: '/IFPageOneHSixtySevenCar',
    name: 'pageOneHSixtySevenCar',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHSixtySevenCarDetails',
    name: 'pageOneHSixtySevenCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },*/
  {
    path: '/IFPageOneHSixtySevenBlank',
    name: 'pageOneHSixtySevenBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/blank.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneHSixtySevenOnlineTab',
    name: 'pageOneHSixtySevenOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/onlineTab.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneHSixtySevenOnlineAd',
    name: 'pageOneHSixtySevenOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHSixtySeven/onlineAd.vue'),
    meta: {
      title: scBrandName,
    },
  },
];
